var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemH2 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M13.667 19V5h-2.78v5.5H4.76V5H2v14h2.761v-5.898h6.125V19zm8 0v-1.846h-3.508c2.231-1.862 3.443-3.324 3.443-5.008 0-1.964-1.444-3.146-3.288-3.146-1.2 0-2.476.502-3.314 1.61l1.044 1.389c.58-.695 1.329-1.138 2.309-1.138.709 0 1.392.414 1.392 1.285 0 1.211-1.031 2.216-4.552 5.2V19z"
})));
export default SvgGemH2;